import {
  ADD_UPDATE_CUSTOMER_FAILURE,
  ADD_UPDATE_CUSTOMER_REQUEST,
  ADD_UPDATE_CUSTOMER_SUCCESS,
  FETCH_LTL_CUSTOMER_LIST_FAILURE,
  FETCH_LTL_CUSTOMER_LIST_REQUEST,
  FETCH_LTL_CUSTOMER_LIST_SUCCESS,
} from "./actionTypes";
import { LtlCustomerState } from "./types";

const initialState: LtlCustomerState = {
  ltlCustomerList: [],
  loading: false,
  error: null,
  totalCount: 0,
  successMessage: "",
};

const ltlCustomerReducer = (
  state = initialState,
  action: any
): LtlCustomerState => {
  switch (action.type) {
    case FETCH_LTL_CUSTOMER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_LTL_CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        ltlCustomerList: action.payload.ltlCustomerList,
        totalCount: action.payload.totalCount,
      };

    case FETCH_LTL_CUSTOMER_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_UPDATE_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ADD_UPDATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload.successMessage,
      };

    case ADD_UPDATE_CUSTOMER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default ltlCustomerReducer;
